import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import dateFormat from "dateformat";
const AgentWithdrawalsDetails = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  useEffect(() => {
    fetch(`https://api.velormall.com/api/admin/withdrawal/view/${id}`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data.data);
      });
  }, []);


  return (
    <>
      

      <div className="d-flex mb-30 flex-wrap gap-3 justify-content-center align-items-center">
        <h6 className="page-title">
          {data?.user_id?.username}  Withdraw Requested &nbsp;
          {data?.amount} USD
        </h6>
        <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins"></div>
      </div>

      <div className="row mb-none-30 justify-content-center">
        <div className="col-lg-6 col-md-6 mb-30">
          <div className="card b-radius--10 overflow-hidden box--shadow1">
            <div className="card-body">
              <h5 className="mb-20 text-muted">
                Withdraw Via {data?.network}
              </h5>
              <ul className="list-group">
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Date
                  <span className="fw-bold">
                    {dateFormat(data.createdAt, "d-m-yyyy h:MM:ss TT")}
                  </span>
                </li>

                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Trx Number
                  <span className="fw-bold"> {data?.transaction}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Username
                  <span className="fw-bold">
                    <Link to={`/agent/user/details/${data?.user_id?._id}`}>
                      {data?.user_id?.username}
                    </Link>
                  </span>
                </li>

                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Amount
                  <span className="fw-bold">{data?.amount} USD</span>
                </li>


                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Payable
                  <span className="fw-bold">
                    {data.status === 1 ? <>{data?.amount} USD</> : <>0 USD</>}
                  </span>
                </li>

                <li className="list-group-item d-flex justify-content-between align-items-center">
                  Status
                  {data.status === 0 ? (
                    <span className="badge badge--warning text-warning">
                      Pending
                    </span>
                  ) : (
                    ""
                  )}
                  {data.status === 1 ? (
                    <span class="badge badge--success text-success">
                      Approved
                    </span>
                  ) : (
                    ""
                  )}
                  {data.status === 2 ? (
                    <span class="badge badge--danger text-danger">
                      Rejected
                    </span>
                  ) : (
                    ""
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgentWithdrawalsDetails;
